import { render, staticRenderFns } from "./ManifestKlaimCCPp.vue?vue&type=template&id=545dd256&scoped=true&"
import script from "./ManifestKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimCCPp.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimCCPp.vue?vue&type=style&index=0&id=545dd256&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545dd256",
  null
  
)

export default component.exports